<div
  *ngIf="isPreviewVisible && _quizData && _quizData.questions.length === 0"
  class="empty-quiz-preview"
>
  <div class="content">
    <h2 class="title">Quiz Questions (0 Questions)</h2>
    <div class="plus-icon">+</div>
    <p class="subtitle">No questions added</p>
    <p class="description">
      Start by adding manual questions or generating with AI
    </p>
  </div>
</div>

<div
  *ngIf="isPreviewVisible && _quizData && _quizData.questions.length > 0"
  class="quiz-preview-container">
  <h2 class="preview-title">
    Quiz Questions ({{ _quizData.questions.length }} Questions)
  </h2>
  <ng-container *ngFor="let quizQuestion of _quizData?.questions; let i = index">
    <div class="question-card">
      <div class="question-header">
        <span class="question-label">Q {{ i + 1 }}</span>
        <span class="question-type">{{ quizQuestion.question_type }}</span>
        <span class="question-points">{{ quizQuestion.marks }} pt</span>
      </div>
      <span *ngIf="quizQuestion.needs_review" class="review-badge">
        &#9888; Needs Review
      </span>
      <div class="question-text">
        <app-question-blocks
          [blocks]="quizQuestion.question_blocks || null"
          [content]="quizQuestion.question_text">
        </app-question-blocks>
        <div *ngIf="quizQuestion.diagram_url || quizQuestion.diagram_payload" class="mt-2 text-start">
          <img [src]="quizQuestion.diagram_url || quizQuestion.diagram_payload" alt="Question Image" class="img-fluid rounded" style="max-height: 200px;">
        </div>
      </div>

      <ul class="options-list" *ngIf="quizQuestion.question_type === 'MCQ'">
        <li *ngFor="let option of quizQuestion.options; let j = index"
          [class.correct]="j === getCorrectOptionIndex(quizQuestion.options ?? [], quizQuestion.correct_answer)">
          <span class="option-prefix">{{ getOptionLabel(j) }} . </span>
          <app-question-blocks
            [blocks]="option.blocks || null"
            [content]="option.text || ''"
            [diagrams]="[]">
          </app-question-blocks>
          <img
            *ngIf="option.image_url && (!option.blocks || option.blocks.length === 0)"
            [src]="option.image_url"
            [alt]="option.text || 'option image'"
            class="option-diagram" />
        </li>
      </ul>

      <div class="csv-badges" *ngIf="hasBadges(quizQuestion)">
        <ng-container
          *ngIf="
            quizQuestion.difficulty_level &&
            quizQuestion.topic &&
            quizQuestion.subject">
          <span class="badge difficulty">
            {{ quizQuestion.difficulty_level }}</span>
          <span class="badge course">{{ quizQuestion.subject }}</span>
          <span class="badge topic">{{ quizQuestion.topic }}</span>
        </ng-container>
      </div>

      <ul class="options-list"
        *ngIf="quizQuestion.question_type === 'TRUE_FALSE'">
        <li [class.correct]="(quizQuestion.correct_answer || '').toString().toLowerCase() === 'true'">
          <span class="option-prefix">A . </span>
          <app-math-latex  [content]="'True'"></app-math-latex>
        </li>
        <li [class.correct]="(quizQuestion.correct_answer || '').toString().toLowerCase() === 'false'">
         <span class="option-prefix">B . </span>
        <app-math-latex  [content]="'False'"></app-math-latex>
        </li>
      </ul>
    </div>

    <div
      class="question-card"
      *ngIf="quizQuestion.question_type === 'OPEN_ENDED'">
      <div class="open-ended-answer">
        <span class="key-answer-label">Key Answer: </span>
        <app-math-latex [content]="quizQuestion.correct_answer"></app-math-latex>
      </div>
    </div>
  </ng-container>
</div>
